import currency from "currency.js";
import { format, parse } from "date-fns";
import { ApplicantDetailsAddressType } from "@lending/types";

function formatDate(timestamp: string): string {
  return format(parse(timestamp, "yyyy-MM-dd", new Date()), "MM/dd/yyyy");
}

/** Format an ISO timestamp or Date as a short month/day, e.g. "Nov 21". */
function formatShortDate(date: string | Date): string {
  return new Intl.DateTimeFormat("en-US", { month: "short", day: "numeric" }).format(
    typeof date === "string" ? new Date(date) : date
  );
}

function formatAddress(address: ApplicantDetailsAddressType) {
  return `${address.street_address}${address.street_address_2 ? `, ${address.street_address_2}` : ""},\n${address.city}, ${address.region_code} ${address.postal_code}`;
}

function formatCentsAsDollars(cents: number) {
  return currency(cents / 100, { precision: 0 }).format();
}

function formatCentsAsDollarsAndCents(cents: number) {
  return currency(cents / 100, { precision: 2 }).format();
}

function formatPhoneNumber(phoneNumber?: string | null) {
  if (phoneNumber == null) {
    return "";
  }

  const digits = phoneNumber.replace(/\D/g, "");
  const localNumber = digits.length > 10 ? digits.slice(-10) : digits;
  return `${localNumber.slice(0, 3)}-${localNumber.slice(3, 6)}-${localNumber.slice(6, 10)}`;
}

function capitalizeFirstLetter(str: string): string {
  if (str.length === 0) {
    return str;
  }
  // Get the first character and capitalize it
  const firstLetter = str.charAt(0).toUpperCase();

  // Get the rest of the str from the second character onwards
  const restOfString = str.slice(1);

  // Concatenate the two parts
  return firstLetter + restOfString;
}

export {
  formatDate,
  formatShortDate,
  formatAddress,
  formatCentsAsDollars,
  formatCentsAsDollarsAndCents,
  formatPhoneNumber,
  capitalizeFirstLetter,
};
